import { PairedCostAdjustmentSummaryTableRow } from './PairedCostAdjustmentSummaryTableRow.tsx';
import { PairedCostAdjustmentSummaryProps } from './types.ts';

export const PairedCostAdjustmentSummaryTableMainDwellingRows = (
  props: PairedCostAdjustmentSummaryProps,
) => {
  const { adjustmentLabels, propertyTypeSet } = props;

  const areaAdjustmentLabels =
    propertyTypeSet.size === 1 && propertyTypeSet.has('multiFamily')
      ? { 'mainDwelling.gla': 'GBA' }
      : adjustmentLabels;

  return (
    <>
      <PairedCostAdjustmentSummaryTableRow
        {...props}
        adjustmentLabels={areaAdjustmentLabels}
        row={{ path: 'mainDwelling.gla', alwaysShow: true }}
      />
      {(propertyTypeSet.has('multiFamily') ||
        propertyTypeSet.has('duplex') ||
        propertyTypeSet.has('triplex') ||
        propertyTypeSet.has('quadruplex')) && (
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{
            path: 'mainDwelling.units',
            alwaysShow: true,
            suppressDetails: false,
          }}
          includeAdjustmentCell
        />
      )}
      {propertyTypeSet.size > 1 && (
        <PairedCostAdjustmentSummaryTableRow
          {...props}
          row={{
            path: 'mainDwelling.propertyType',
            alwaysShow: true,
            suppressDetails: true,
          }}
          includeAdjustmentCell={false}
        />
      )}
    </>
  );
};
